import { gql, TypedDocumentNode } from '@common/hooks';
import {
  SaveWorkerProfileChangeMutationCgResponse,
  SaveWorkerProfileChangeMutationVariables,
} from '@common/graphql';
import { FullValidationErrorFragment } from '@common/graphql/fragments';

// Creates or edits an effective-dated worker profile change (WORK-6258). Omit `termId` to
// create; pass it to edit an existing change. The returned worker carries its refreshed term
// history (same selection as LOAD_BALANCING_WORKER_QUERY) so the read views update in place.
export const SAVE_WORKER_PROFILE_CHANGE_MUTATION: TypedDocumentNode<
  SaveWorkerProfileChangeMutationCgResponse,
  SaveWorkerProfileChangeMutationVariables
> = gql`
  mutation SaveWorkerProfileChange(
    $workerId: ID!
    $termId: ID
    $effectiveStartDate: ISO8601Date
    $effectiveEndDate: ISO8601Date
    $accountActive: Boolean!
    $role: String!
    $ftePercentage: Float
    $chargeEligible: Boolean!
    $preferredTime: LoadBalancingScheduleShiftPreference!
    $shiftPatternPreference: LoadBalancingShiftPatternPreference!
    $schedulingPeriodId: ID
  ) {
    saveWorkerProfileChange(
      workerId: $workerId
      termId: $termId
      effectiveStartDate: $effectiveStartDate
      effectiveEndDate: $effectiveEndDate
      accountActive: $accountActive
      role: $role
      ftePercentage: $ftePercentage
      chargeEligible: $chargeEligible
      preferredTime: $preferredTime
      shiftPatternPreference: $shiftPatternPreference
      schedulingPeriodId: $schedulingPeriodId
    ) {
      termId
      worker {
        id
        name
        terms {
          id
          active
          effectiveStartDate
          effectiveEndDate
          employmentType
          role
          homeUnit
          fteHours
          ftePercentage
          preferredTime
          shiftPatternPreference
          chargeEligible
        }
      }
      errors {
        ...FullValidationErrorFragment
      }
    }
  }
  ${FullValidationErrorFragment}
`;
